import * as React from "react";

import { Wrapper } from "../../../components";
import "./Price.css";

export interface PriceProps {
  searchInput: JSX.Element;
  children?: JSX.Element;
}

const Price = (props: PriceProps) => (
  <Wrapper>
    <div className="row">
      <div className="col-md-2">
        <h1 className="title">
          giá <b>Tối ưu</b>
        </h1>
      </div>
      <div className="col-md-8">{props.searchInput}</div>
    </div>
    {props.children}
  </Wrapper>
);

export default Price;



// WEBPACK FOOTER //
// ./src/routes/Price/components/Price.tsx